import type { PermissionCode, RoleSlug, UserRole } from './types';

export function hasPermission(permissions: string[], code: PermissionCode): boolean {
  return permissions.includes(code);
}

export function hasAnyPermission(permissions: string[], codes: PermissionCode[]): boolean {
  return codes.some((code) => permissions.includes(code));
}

export function hasAllPermissions(permissions: string[], codes: PermissionCode[]): boolean {
  return codes.every((code) => permissions.includes(code));
}

export function hasRole(roles: UserRole[], slug: RoleSlug): boolean {
  return roles.some((ur) => ur.role?.slug === slug);
}

export function hasAnyRole(roles: UserRole[], slugs: RoleSlug[]): boolean {
  return roles.some((ur) => slugs.includes(ur.role?.slug as RoleSlug));
}

export function getHighestRole(roles: UserRole[]): UserRole | null {
  if (roles.length === 0) return null;
  return roles.reduce((highest, current) => {
    const currentLevel = current.role?.hierarchy_level ?? 0;
    const highestLevel = highest.role?.hierarchy_level ?? 0;
    return currentLevel > highestLevel ? current : highest;
  });
}
